import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopRoutingModule } from './top-routing.module';
import { TopComponent } from './top.component';
var TopModule = /** @class */ (function () {
    function TopModule() {
    }
    TopModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule, TopRoutingModule
                    ],
                    declarations: [TopComponent]
                },] }
    ];
    return TopModule;
}());
export { TopModule };
//# sourceMappingURL=top.module.js.map